/* ============================================================================
   Deal Basket — live search. Products appear under any search box while typing,
   using Shopify's own Predictive Search (no app, no extra cost).
   Works on the search page, collection pages and anywhere an
   <input type="search" name="q"> is used. Enter still opens the full results page.
   ========================================================================== */
(function () {
  'use strict';
  var inputs = document.querySelectorAll('input[type="search"][name="q"]');
  if (!inputs.length || !window.fetch) return;
  var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  var searchUrl = '/search';
  var uid = 0;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function price(p) {
    var cents = Math.round(parseFloat(p || 0) * 100);
    return window.dbFormatMoney ? window.dbFormatMoney(cents) : '\u20B9' + (cents / 100).toFixed(2);
  }
  function thumb(img) {
    if (!img || !img.url) return '';
    var u = img.url + (img.url.indexOf('?') > -1 ? '&' : '?') + 'width=96';
    return '<img src="' + esc(u) + '" alt="" width="44" height="44" loading="lazy">';
  }
  function mark(title, q) {
    var t = esc(title), w = esc(q).trim();
    if (!w) return t;
    var i = t.toLowerCase().indexOf(w.toLowerCase());
    return i < 0 ? t : t.slice(0, i) + '<b>' + t.slice(i, i + w.length) + '</b>' + t.slice(i + w.length);
  }

  Array.prototype.forEach.call(inputs, function (input) {
    var form = input.form;
    var host = input.parentElement;
    if (!host) return;
    if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var id = 'db-ps-' + (++uid);
    var panel = document.createElement('div');
    panel.className = 'db-ps';
    panel.id = id;
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    host.appendChild(panel);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', id);
    input.setAttribute('aria-expanded', 'false');

    var timer = null, ctrl = null, lastQ = '';
    function open(on) { panel.hidden = !on; input.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    function allLink(q) {
      return '<a class="db-ps__all" href="' + searchUrl + '?type=product&q=' + encodeURIComponent(q) + '">See all results for \u201C' + esc(q) + '\u201D &rarr;</a>';
    }
    function render(q, products) {
      if (!products.length) {
        panel.innerHTML = '<div class="db-ps__none">No products found for \u201C' + esc(q) + '\u201D. Try another word.</div>' + allLink(q);
      } else {
        panel.innerHTML = products.map(function (p) {
          var sale = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price);
          return '<a class="db-ps__item" role="option" href="' + esc(p.url) + '">' + thumb(p.featured_image) +
            '<span class="db-ps__t">' + mark(p.title, q) + '</span>' +
            '<span class="db-ps__p">' + price(p.price) + (sale ? ' <s>' + price(p.compare_at_price_max) + '</s>' : '') + '</span></a>';
        }).join('') + allLink(q);
      }
      open(true);
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { open(false); lastQ = ''; return; }
      if (q === lastQ) { open(true); return; }
      lastQ = q;
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== input.value.trim()) return;
          var res = data && data.resources && data.resources.results;
          render(q, (res && res.products) || []);
        })
        .catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2) run(); });
    input.addEventListener('keydown', function (e) {
      var items = panel.querySelectorAll('a');
      if (e.key === 'ArrowDown' && !panel.hidden && items.length) { e.preventDefault(); items[0].focus(); }
      if (e.key === 'Escape') open(false);
    });
    panel.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(panel.querySelectorAll('a'));
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else items[i - 1].focus(); }
      if (e.key === 'Escape') { open(false); input.focus(); }
    });
    document.addEventListener('click', function (e) { if (!host.contains(e.target)) open(false); });
    if (form) form.addEventListener('submit', function () { open(false); });
  });
})();
